import { Check } from "lucide-react";
import "./LandingBeforePay.css";

const ITEMS = [
  "Uma questão de exemplo",
  "O que cada plano inclui",
  "O preço e as regras de reembolso",
  "Como falar com a gente",
];

export default function LandingBeforePay() {
  return (
    <section aria-label="Antes de pagar, você vê" className="lbp">
      <div className="lbp-bar" aria-hidden="true" />
      <h2 className="lbp-heading">Antes de pagar, você vê:</h2>
      <ul className="lbp-list">
        {ITEMS.map((item) => (
          <li key={item} className="lbp-card">
            <span className="lbp-check" aria-hidden="true">
              <Check size={20} />
            </span>
            <span className="lbp-line">{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
